// RollingRangeWidget/RollingRangeFetcher.js
// Singleton — does exactly 1 thing: raw I/O via HistoryService. No mapping, no business logic.
import historyService from '../../../services/HistoryService';
import CoreBase from '../../../services/engines/CoreBase';

const _name = 'RollingRangeFetcher';

class RollingRangeFetcher extends CoreBase {
    _name = _name;

    /**
     * Fetches the rolling-range candles for ALL assets and ALL windows (7/14/30/90) in
     * one call (sid=0, window=0).
     * @returns {Promise<{rk:string,sid:number,ems:number,ov:number,hv:number,lv:number,cv:number,ot:number,ht:number,lt:number,ct:number,side:number,type:number,oh:number,ol:number,oc:number,lh:number,ums:number}[]>}
     */
    fetchAll = async () => {
        try {
            const res = await historyService.getRollingWindows(0, 0);
            return res?.data?.items ?? [];
        } catch (error) {
            this.logError('fetchAll', error.message);
            return [];
        }
    };
}

const rollingRangeFetcher = new RollingRangeFetcher();
export default rollingRangeFetcher;
